<template>
  <CustomModal
    :id="`editor-modal-link-${id}`"
    modalClass="custom-modal_margin-md"
    @onOpened="onOpened"
  >
    <template #header>
      <h2>Add Url</h2>
    </template>
    <template #body>
      <form
        class="form"
        @submit.prevent="onActionEvent"
      >
        <div class="form__line">
          <BorderedInput
            id="url"
            :modelValue="url"
            label="Url"
            :triggerFocus="focusOnUrl"
            @update:modelValue="handleInput"
          />
        </div>
      </form>
    </template>
    <template #footer="{ hide }">
      <ControlButtons
        @save="onActionEvent(hide)"
        @cancel="hide"
      >
        <template #save> Continue </template>

        <template #cancel> Close </template>
      </ControlButtons>
    </template>
  </CustomModal>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Emit, Prop } from "vue-property-decorator"

import ControlButtons from "@/components/ControlButtons/index.vue"
import BorderedInput from "@/components/Form/BorderedInput.vue"
import CustomModal from "@/components/Modal/index.vue"

import { CallbackFunction } from "@/models"

@Options({
  name: "EditorModalLink",
  components: {
    BorderedInput,
    CustomModal,
    ControlButtons
  }
})
export default class EditorModalLink extends Vue {
  @Prop({
    default: ""
  })
  id: string
  url = ""
  focusOnUrl = false

  handleInput({ value }: { value: string }) {
    this.url = value
  }

  onActionEvent(callback: CallbackFunction) {
    this.toParent()
    callback()
    this.url = ""
    this.focusOnUrl = false
  }

  onOpened() {
    this.focusOnUrl = false
    this.$nextTick(() => {
      this.focusOnUrl = true
    })
  }

  @Emit("onAction")
  toParent(): string {
    return this.url
  }
}
</script>
